import React from "react";
import ReactDOM from "react-dom";
import { browserName } from "react-device-detect";
import "./style.less";

/** Browser not supported window */
ReactDOM.render(
  <div className={"notSupport"}>
    <span className={"message"}>{`${browserName} ${"Browser not supported!"}`}</span>
  </div>,
  document.getElementById("root")
);
